import { useAsset } from "provider/AssetProvider";
import { useWallet } from "provider/WalletProvider";
import { useNavigate } from "react-router-dom";
import { copy, formatAddress } from "utils/Helpers";

export function Navbar() {
    const { disconnect, address } = useWallet()
    const { tokenInfo } = useAsset()
    const navigate = useNavigate()

    return <nav
        className="layout-navbar container-fluid navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme color-black"
        id="layout-navbar"
    >
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
            <a className="nav-item nav-link px-0 me-xl-4" href="#">
                <i className="bx bx-menu bx-sm"></i>
            </a>
        </div>

        <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">

            <div className="navbar-nav align-items-center">
                <div className="nav-item d-flex align-items-center">

                    <span
                        data-bs-toggle="tooltip"
                        data-bs-offset="0,4"
                        data-bs-placement="bottom"
                        title="Active Asset"
                        className={`cursor-pointer badge bg-label-primary ms-2 ${tokenInfo ? 'd-inline' : "d-none"}`}>
                        {tokenInfo?.name}
                    </span>
                </div>
            </div>

            <ul className="navbar-nav flex-row align-items-center ms-auto">

                {
                    !address && <button data-bs-toggle="modal"
                        data-bs-target="#wallet-modal"
                        className="nav-item btn btn-primary">Connect</button>
                }

                {
                    address &&
                    <div className="nav-item btn-group navbar-dropdown dropdown">
                        <button
                            type="button"
                            className="btn btn-outline-primary dropdown-toggle hide-arrow"
                            data-bs-toggle="dropdown"
                        >
                            {formatAddress(address)}
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end">
                            <li><button onClick={() => navigate("/my-assets")} className="dropdown-item">My Assets</button></li>
                            <li><button onClick={() => copy(address)} className="dropdown-item">Copy</button></li>
                            <li><button onClick={() => disconnect()} className="dropdown-item text-danger">Disconnect</button></li>
                        </ul>
                    </div>
                }

            </ul>
        </div>
    </nav>
}